import { render } from "./h4h_post_purchase_item.vue?vue&type=template&id=7da2567b"
import script from "./h4h_post_purchase_item.vue?vue&type=script&lang=js"
export * from "./h4h_post_purchase_item.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__